module.exports = __webpack_public_path__ + "static/hosni-9c5600f85c8c0010173f0d7b2709f9d6.png";